<template>
  <div class="wrapper">
    <div class="sidebar">
        {{menuRoutes}}
    </div>
    <router-view></router-view>
  </div>
</template>

<script>

export default {
    name: 'settings',
    computed: {
        menuRoutes() {
            const result = this.$router.options.routes.filter(route => route.path === '/settings')
            return result;
        }
    }
};
</script>

<style lang="scss" scoped>
</style>
